import { ISite } from 'components/SiteList/SiteList';
import { IAPIContext } from 'models/context/api-context';
import { Oauth2PostSiteResponseSuccess, Convert as SuccessConvert } from 'models/schema-generated-models/api-response-bodies/oauth2-post-site-response-success';
import { SSOAPIContextParser } from 'services/api-context-service/sso-api-context-parser';
import {
    SSOAPIUnexpectedResponseBody
} from 'services/errors';
import { BaseService } from 'services/sso-api/base-service';
import { ClientResponse } from '../client/client-response';

export enum AuthenticationRoute {
    OAUTH2_SITE_RESPONSE = '/oauth2/site-response'
}

export class AuthenticationService extends BaseService {
    authenticateETOBySite = async (token: string, site: ISite, ssoAPIContext: IAPIContext): Promise<URL> => {
        const response: ClientResponse = await this.client.post(AuthenticationRoute.OAUTH2_SITE_RESPONSE, {
            headers: {
                sitelisttoken: token
            },
            body: JSON.stringify(site)
        }, ssoAPIContext);
        const body = await response.text();
        const responseAPIContext = SSOAPIContextParser.getSSOAPIContextFromResponse(response);
        
        if (response.status === 200) {
            let siteResponseBody: Oauth2PostSiteResponseSuccess;
            try {
                siteResponseBody = SuccessConvert.toOauth2PostSiteResponseSuccess(body);
            } catch (err) {
                throw new SSOAPIUnexpectedResponseBody(responseAPIContext, 'Unexpected response body from successful return.', { cause: err as Error, requestStartTimeMS: response.requestStartTimeMS, requestEndTimeMS: response.requestEndTimeMS});
            }
            try {
                return new URL(siteResponseBody.location);
            } catch (err: unknown) {
                throw new SSOAPIUnexpectedResponseBody(responseAPIContext, `'location' value of ${siteResponseBody.location} could not be converted into a URL object.`, { cause: err as Error, requestStartTimeMS: response.requestStartTimeMS, requestEndTimeMS: response.requestEndTimeMS});
            }
        }
        throw this.processGeneralAPIError(response, body, responseAPIContext);
    };
}
